import { JOBS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";

export const FlatJobService = {
  getAll: (params: IPagination) => requests.get(`${JOBS_URL}/flat-jobs`, params),
  updateStatus: (id: number, isFlatOnly: boolean) =>
    requests.patch(`${JOBS_URL}/job-flat/status/${id}`, { isFlatOnly }),
  delete: (id: number) => requests.delete(`${JOBS_URL}/${id}`),
};
